<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="__kfc_popup_right">
    <div class="top">
      <div class="arrow" @click="toggleContactMode">
        <img src="@/assets/images/arrow-forward.svg" alt="arrow" />
      </div>
      <div class="wrapper">
        <div class="title">
          {{ $t('contInformation') }}
        </div>
        <el-form @submit.prevent="handleSubmit(refForm)" ref="refForm" class="__kfc_login_form __kfc_form" label-position="top" label-width="100px" :rules="rules"
          :model="form" status-icon>
          <el-form-item :label="$t('phoneNo')" class="form_item" prop="phone">
            <el-input class="__kfc_r_8" v-model="form.phone" :placeholder="$t('phoneNo')" />
          </el-form-item>
          <el-form-item :label="$t('email')" class="form_item" prop="email">
            <el-input class="__kfc_r_8" v-model="form.email" :placeholder="$t('email')" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="bottom">
      <button type="button" @click="handleSubmit(refForm)">{{ $t('save') }}</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.__kfc_popup_right {
  .top {
    display: flex;
    flex-direction: column;
    gap: 30px;

    .wrapper {
      display: flex;
      flex-direction: column;
      gap: 40px;

      .title {
        color: $darkMain;
        font-family: Oswald;
        font-size: 24px;
        font-weight: 500;
        line-height: 30px;
        /* 125% */
        text-transform: uppercase;
      }

      .form-wrap {
        display: flex;
        flex-direction: column;
        gap: 24px;

        .form {
          display: flex;
          flex-direction: column;
          gap: 8px;

          label {
            color: $dark40;
            font-size: 13px;
            font-weight: 500;
            line-height: 16px;
            /* 123.077% */
            letter-spacing: -0.3px;
          }

          input {
            border-radius: 4px;
            border: none;
            background: $dark5;
            padding: 16px;

            &:focus {
              outline: none;
            }
          }
        }
      }
    }
  }

  .bottom {
    padding: 0 40px;

    button {
      width: 100%;
      border: none;
      background: $redMain;
      color: $whiteMain;
      border-radius: 4px;
      padding: 16px 30px;
    }
  }
}
</style>

<script>
import router from "@/router";
import Req from "@/utils/Request";
import axios from "axios";
import { computed, inject, reactive, ref } from 'vue';
import { useStore } from 'vuex';

export default {
  props: {
    toggleContactMode: Function,
    toggleContact: Boolean,
    toggleProfileMode: Function,
  },
  setup(props) {
    const { toggleProfileMode } = props;
    const store = useStore();
    const notify = inject('notify');
    const getUser = computed(() => store.getters['user/getUser']);
    const locale = computed(() => store.getters['locale']);
    const refForm = ref(null);
    const form = reactive({
      phone: getUser.value.phone,
      email: getUser.value.email,
    });
    const rules = reactive({
      phone: [{
        required: true,
        message: locale.value == 'mn' ? 'Утасны дугаар заавал байх ёстой' : 'Phone number required',
        trigger: 'blur'
      },
      {
        required: true,
        len: 8,
        message: 'Утасны дугаараа зөв оруулна уу',
        trigger: 'change'
      }],
      email: [{
        required: true,
        type: 'email',
        message: locale.value == 'mn' ? 'Мэйл хаяг шаардлага хангахгүй байна' : 'Email required',
        trigger: ['blur', 'change']
      }],
    });
    const handleSubmit = async (formEl) => {
      if (!formEl)
        return;
      await formEl.validate(async (valid) => {
        if (valid) {
          const payload = {
            id: getUser.value.id,
            phone: form.phone,
            email: form.email,
          }
          const { data: result } = await axios.post(`${process.env.VUE_APP_SERVER_PATH}/manager/setInfo`, payload, { withCredentials: true })
          if (result.success) {
            notify({
              type: 'success',
              message: result.message,
            });
            store.dispatch('user/updateUser', {
              phone: result.result.phone,
              email: result.result.email,
            })
            //   handleClose();
            //   // router.push('/basket');
          }else {
            if(result.statusCode === 401){
              store.dispatch('user/deleteUser');
              router.push('/');
              toggleProfileMode();
            }
              notify({
                type: 'error',
                message: result.message,
              });
          }
        }
      });

    }
    return {
      form, rules, locale, refForm, handleSubmit
    }
  }
};
</script>
